import "../css/Loading.css";

export const PulsingDots = () => {
    return <div className="pulse-marker-container">
        <i className="dot fa-solid fa-circle"></i>
        <i className="dot fa-solid fa-circle"></i>
        <i className="dot fa-solid fa-circle"></i>
    </div>
}